module.exports = __webpack_public_path__ + "static/media/bg4k.c459fe17.jpg";